import "../styles/question.css";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Component } from "./dynamiccomponents";
import axios from "../../api/axios";
import Missing from "../../Missing";
import { GlobalContext } from "../../context/GlobalContext";
import { useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import StepShell from "../stepper/StepShell";
import {
  mapResumeDataToState,
  inferResumeStepIndex,
  applyUrlEquipmentPrefill,
  restoreAddressComponents,
} from "../stepper/resumeApplication";

// PD-22: client asked to hide the Business/Personal fork for now — too many
// Personal-path applications were starting and never finishing. This is a
// deliberate GLOBAL override (confirmed with the client), not per-tenant: it
// forces `state.isPersonalFlow` to always resolve false here, at the single
// point it enters the app from the backend, regardless of what any
// individual company's own `Company.is_personal_flow` DB flag says. Every
// downstream consumer (StepYou.js's chip/validation, StepShell.js's step
// routing, this file's own resume-step inference below) reads only
// `state.isPersonalFlow`, so overriding it here is enough — nothing else
// needs to change, and re-enabling later is just deleting this line.
const PERSONAL_FLOW_ENABLED = false;

function Question() {
  const [component, setComponent] = useState("GetStarted");
  const [showLoader, setShowLoader] = useState(true);
  const { state, dispatch } = useContext(GlobalContext);
  const [pageNotFound, setPageNotFound] = useState(false);
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  // Resume flow (PD-20 "Save & finish later"): a magic link carries ?uuid=
  // for a PartialApplication already in progress.
  const resumeUUID = params.get("uuid");
  const resumeLoadingRef = useRef(!!resumeUUID);
  const [resumeStepIndex, setResumeStepIndex] = useState(0);
  const BOOM_AND_BUCKET_DOMAIN = "www.boomandbucket.com";
  const CRANE_MARKET_DOMAIN = "cranemarket.com";
  const IRON_POWER_DOMAIN = "ironpowerindustries.com";
  const HIMES_EQUIPMENT_DOMAIN = "www.himesequipment.com";
  const SOARR_DOMAIN = "www.soarr.com";
  const AERIALTITANS_DOMAIN = "www.aerialtitans.com";
  const IRON_EXCHANGE_LLC_DOMAIN = "www.ironexchangellc.com";
  const LAMPAS_RENTAL_DOMAIN = "www.lampasasrental.com";
  const HIGH_DESERT_TRAILERS_DOMAIN = "www.highdeserttrailers.com";

  let link = null;
  let cost = null;
  let machine_model = null;
  let machine_year = null;
  let machine_make = null;
  let query_image = null;
  let query_icn = null;
  let query_auction = null;
  let query_listing_url = null;

  console.log("state", state);
  console.log("questions", state?.questions);

  const pathSegments = pathname.split("/");
  if (pathSegments.length === 3) {
    link = pathSegments[2];
  } else if (pathSegments.length === 4 && pathSegments[3] === "") {
    link = pathSegments[2];
  }

  if (params.has("cost")) {
    cost = +params.get("cost");
  } else if (params.has("Price")) {
    cost = +params.get("Price");
  } else if (params.has("price")) {
    // Lowercase variant — Purple Wave (and others) sends this casing.
    cost = +params.get("price");
  }
  if (params.has("machine_model")) {
    machine_model = params.get("machine_model");
  } else if (params.has("Model")) {
    machine_model = params.get("Model");
  }
  if (params.has("machine_year")) {
    machine_year = params.get("machine_year");
  } else if (params.has("Year")) {
    machine_year = params.get("Year");
  }
  if (params.has("machine_make")) {
    machine_make = params.get("machine_make");
  } else if (params.has("Make")) {
    machine_make = params.get("Make");
  }
  if (params.has("Image")) {
    query_image = params.get("Image");
  }
  if (params.has("image")) {
    query_image = params.get("image");
  }
  if (params.has("icn")) {
    query_icn = params.get("icn");
  }
  if (params.has("auction")) {
    query_auction = params.get("auction");
  } else if (params.has("auction_id")) {
    query_auction = params.get("auction_id");
  }
  if (params.has("listing_url")) {
    query_listing_url = params.get("listing_url");
  }

  const [progress, setProgress] = useState(0);

  var paramsArray = [machine_model, machine_make, machine_year].filter(
    (value) => {
      return value !== undefined && value !== null && value !== "";
    }
  );

  var param = paramsArray.join("-");

  // Use ref to preserve query_image across async operations
  const queryImageRef = useRef(query_image);

  // Store query params image in state for persistence
  useEffect(() => {
    if (query_image) {
      queryImageRef.current = query_image;
      const obj = { ...state.questions };
      obj.queryParamImageUrl = query_image;
      dispatch({
        type: "QUESTIONS",
        payload: obj,
      });
    }
  }, []);

  // A ?cost=/?Price= URL param is the top-priority source for the
  // Equipment step's price (see GetStarted.js, which reads this to send
  // url_equipment_price on application creation, and
  // PartialApplicationCreateOrUpdateView.return_application_response's
  // priority logic) — store it in state here since GetStarted.js doesn't
  // itself have access to the URL's query params.
  useEffect(() => {
    if (cost !== null && !isNaN(cost)) {
      dispatch({
        type: "QUESTIONS",
        payload: { ...state.questions, urlEquipmentPrice: cost },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Purple Wave sends icn/auction(_id)/listing_url as URL params on landing
  // — this is what distinguishes Purple Wave traffic from every other
  // marketing-link/referrer source (see isPurpleWave in GetStarted.js and
  // StepEquipment.js). Only the fields actually present are dispatched;
  // the QUESTIONS reducer merges rather than replaces, so this can't
  // clobber whatever another effect (e.g. the price one above) has set.
  useEffect(() => {
    const payload = {};
    if (query_icn) {
      payload.purpleWaveIcn = query_icn;
      payload.purpleWaveIcnFromLink = true;
    }
    if (query_auction) payload.purpleWaveAuctionId = query_auction;
    if (query_listing_url) payload.purpleWaveListingUrl = query_listing_url;
    if (Object.keys(payload).length > 0) {
      dispatch({
        type: "QUESTIONS",
        payload,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const referrer = document.referrer;
    const obj = { ...state.questions };
    // This will get the url if the user is coming from external website
    if (referrer) {
      let domainName = null;
      let apiBaseUrl = null;
      try {
        const referrerURL = new URL(referrer);
        domainName = referrerURL.hostname;
      } catch (err) {}
      if (
        domainName === BOOM_AND_BUCKET_DOMAIN ||
        domainName === CRANE_MARKET_DOMAIN ||
        domainName === IRON_POWER_DOMAIN ||
        domainName === SOARR_DOMAIN ||
        domainName === AERIALTITANS_DOMAIN ||
        domainName === IRON_EXCHANGE_LLC_DOMAIN ||
        domainName === HIGH_DESERT_TRAILERS_DOMAIN ||
        domainName === LAMPAS_RENTAL_DOMAIN
      ) {
        obj.referrerUrl = referrer;
        // Preserve queryParamImageUrl from ref
        if (queryImageRef.current) {
          obj.queryParamImageUrl = queryImageRef.current;
        }
        dispatch({
          type: "QUESTIONS",
          payload: obj,
        });
      }
      if (domainName === BOOM_AND_BUCKET_DOMAIN) {
        apiBaseUrl = "lender/scrape/boom-and-bucket/";
      } else if (domainName === CRANE_MARKET_DOMAIN) {
        apiBaseUrl = "lender/scrape/crane-market/";
      } else if (domainName === IRON_POWER_DOMAIN) {
        apiBaseUrl = "lender/scrape/iron-power/";
      } else if (domainName === SOARR_DOMAIN) {
        apiBaseUrl = "lender/scrape/soarr/";
      } else if (domainName === AERIALTITANS_DOMAIN) {
        apiBaseUrl = "lender/scrape/aerial-titans/";
      } else if (domainName === IRON_EXCHANGE_LLC_DOMAIN) {
        apiBaseUrl = "lender/scrape/iron-exchange/";
      } else if (domainName === HIGH_DESERT_TRAILERS_DOMAIN) {
        apiBaseUrl = "lender/scrape/high-desert-trailers/";
      } else if (domainName === LAMPAS_RENTAL_DOMAIN) {
        apiBaseUrl = "lender/scrape/lampass-rental-and-hardware/";
      } else {
        apiBaseUrl = "";
      }
      console.log("referrer", referrer);
      axios
        .post(
          apiBaseUrl,
          { url: referrer },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          const response = res?.data;
          //in case of soarr, miles exists so add in redux obj
          if (response?.marketing_equipment_miles)
            obj.referrerEquipmentMiles = response?.marketing_equipment_miles;
          obj.referrerEquipmentDescription = response?.marketing_equipment_name;
          obj.referrerEquipmentCost = response?.marketing_equipment_price;
          obj.referrerEquipmentImageUrl =
            response?.marketing_equipment_image_url;
          obj.referrerEquipmentMonthlyCost =
            response?.marketing_equipment_monthly_cost;
          // Preserve queryParamImageUrl from ref
          if (queryImageRef.current) {
            obj.queryParamImageUrl = queryImageRef.current;
          }
          dispatch({
            type: "QUESTIONS",
            payload: obj,
          });
        })
        .catch((err) => {})
        .finally(() => {
          if (!resumeLoadingRef.current) setShowLoader(false);
        });
    } else {
      if (!resumeLoadingRef.current) setShowLoader(false);
    }
  }, []);

  useEffect(() => {
    axios
      .post(
        "lender/validate-slug/",
        { link: link, equipment_price: cost, equipment_name: param },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.link_type === "Marketing") {
          const updatedUser = {
            ...state.user,
            logo: res?.data?.company_logo,
            themeColor: res?.data?.theme_color,
          };
          dispatch({
            type: "USER_INFO",
            payload: updatedUser,
          });
          // Dispatch only the changed fields — this response can resolve
          // well after the mount-time query-params effects above (Purple
          // Wave icn/auction/listing_url, url price, etc.) have already
          // set their own fields into state.questions. Spreading
          // `...state.questions` here would capture this effect's own
          // *stale* pre-effect closure snapshot and wholesale overwrite
          // those already-set fields back to blank.
          dispatch({
            type: "QUESTIONS",
            payload: {
              isMarketingLink: true,
              // Preserve queryParamImageUrl from ref
              ...(queryImageRef.current && { queryParamImageUrl: queryImageRef.current }),
            },
          });
          dispatch({
            type: "INFORMATION_SLUG",
            payload: res?.data?.slug,
          });
          dispatch({
            type: "PERSONAL_FLOW",
            payload: PERSONAL_FLOW_ENABLED && res?.data?.is_personal_flow,
          });
          dispatch({
            type: "SALES_REP_FLOW",
            payload: res?.data?.is_sales_rep_flow_enabled,
          });
          dispatch({
            type: "PURPLE_WAVE_ACCOUNT",
            payload: Boolean(res?.data?.is_purple_wave_account),
          });
        } else {
          const updatedUser = {
            ...state.user,
            logo: res?.data?.company_logo,
            themeColor: res?.data?.theme_color,
            isDefault: res?.data?.is_default,
          };
          dispatch({ type: "USER_INFO", payload: updatedUser });
          dispatch({
            type: "INFORMATION_SLUG",
            payload: res?.data?.slug,
          });
          dispatch({
            type: "PERSONAL_FLOW",
            payload: PERSONAL_FLOW_ENABLED && res?.data?.is_personal_flow,
          });
          dispatch({
            type: "SALES_REP_FLOW",
            payload: res?.data?.is_sales_rep_flow_enabled,
          });
          dispatch({
            type: "PURPLE_WAVE_ACCOUNT",
            payload: Boolean(res?.data?.is_purple_wave_account),
          });
        }
      })
      .catch((err) => {
        console.log(err, "err");
        setPageNotFound(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Resume flow (PD-20 "Save & finish later"): once the slug resolves,
  // fetch the saved PartialApplication by uuid, hydrate GlobalContext, and
  // jump straight into the stepper at the step the borrower left off on —
  // skipping GetStarted's fresh-application-creation POST entirely.
  useEffect(() => {
    if (!resumeUUID || !state.informationSlug) return;

    axios
      .get(`lender/partial-application/${state.informationSlug}/?uuid=${resumeUUID}`)
      .then((res) => {
        const data = res.data;
        const { questions, business, personal } = mapResumeDataToState(data, state.questions);
        // Before the stepper mounts — each step reads these on init.
        restoreAddressComponents(data);
        // The resume link carries the original third-party query params
        // (see SavePartialApplicationForLaterView), so year/make/model can
        // be re-applied from the URL like a fresh visit does in GetStarted.js.
        dispatch({
          type: "QUESTIONS",
          payload: { ...questions, business, personal: applyUrlEquipmentPrefill(personal, search) },
        });
        dispatch({ type: "APPLICATION_UUID", payload: resumeUUID });
        // Mirrors StepShell.js's own derivation: `state.isPersonalFlow` is
        // only the permission flag, the borrower's actual path is whatever
        // they answered on StepYou.js's "How will you use the equipment?"
        // question, saved as `data.equipment_use`.
        setResumeStepIndex(
          inferResumeStepIndex(
            data,
            Boolean(state?.isPersonalFlow) && data.equipment_use === "Personal"
          )
        );
        setComponent("Stepper");
      })
      .catch((err) => {
        console.log(err, "resume err");
        // Not found / expired link — fall back to a fresh application
        // rather than blocking the borrower entirely.
      })
      .finally(() => {
        resumeLoadingRef.current = false;
        setShowLoader(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resumeUUID, state.informationSlug]);

  return (
    <>
      {pageNotFound ? (
        <Missing />
      ) : showLoader ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner style={{ width: "4rem", height: "4rem" }} />
        </div>
      ) : (
        state?.informationSlug !== "" && (
          // PD-6: the application goes straight from the marketing link into
          // the stepper — "GetStarted" is just a brief application-creation
          // spinner (no landing page/Start button anymore). `component` here
          // is only ever "GetStarted" or "Stepper" (see dynamiccomponents.js
          // and GetStarted.js — every path sets one of these two).
          component === "GetStarted" ? (
            <Component
              {...{ component, setComponent, setProgress, progress }}
            />
          ) : (
            <StepShell initialStepIndex={resumeStepIndex} />
          )
        )
      )}
    </>
  );
}

export default Question;
